import { IconButton } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import React from "react";
import { db } from "../../../../firebase";
import "./SelectedSkillCard.css";

const getDate = (t) => {
  if (!t) {
    return null;
  }
  // const t = new Date(1970, 0, 1);
  // t.setSeconds(sec);
  const time = t.toLocaleDateString();
  // console.log(t.toISOString().substr(0, 10));
  return time;
};

function SelectedSkillCard({ data, relodState }) {
  const [, setRelod] = relodState;

  const deleteHandler = async () => {
    try {
      await db.collection("Skills").doc(data.key).delete();
      setRelod((p) => !p);
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <div className="selectedSkillCard">
      <div className="selectedSkillCard__imageContainer">
        <img
          onClick={() => window.open(data.mediaURL, "_blank")}
          src={
            data.mediaURL
              ? data.mediaURL
              : "https://kubalubra.is/wp-content/uploads/2017/11/default-thumbnail.jpg"
          }
          alt=""
        />
      </div>
      <div className="selectedSkillCard__info">
        <p className="selectedSkillCard__info__title">{data.title}</p>
        <p className="selectedSkillCard__info__name">By: {data.name}</p>
        <p className="selectedSkillCard__info__description">
          {data.description}
        </p>

        <p className="selectedSkillCard__info__date">
          {getDate(data.uploadedDate.toDate())}
        </p>
        <p
          className="selectedSkillCard__info__link"
          onClick={() => window.open(data.youtubeVideoLink, "_blank")}
        >
          {data.youtubeVideoLink ? "YouTube" : null}
        </p>
        <div className="selectedSkillCard__delete">
          <IconButton onClick={deleteHandler}>
            <Delete style={{ color: "#f95738" }} />
          </IconButton>
        </div>
      </div>
    </div>
  );
}

export default SelectedSkillCard;
